import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.5.5c-.7-.7-1.8-.7-2.4 0L12 9.6 2.9.5C2.2-.2 1.1-.2.5.5s-.7 1.8 0 2.4L9.6 12 .5 21.1c-.7.7-.6 1.8 0 2.4.7.6 1.7.6 2.4 0l9.1-9.1 9.1 9.1c.7.7 1.8.7 2.4 0 .7-.7.7-1.8 0-2.4L14.4 12l9.1-9.1c.7-.6.7-1.7 0-2.4z" fill="#FFF" /></svg>;
}
export default SvgComponent;